export default __webpack_public_path__ + "static/media/unitCover.d76ea946.jpg";